module.exports = __webpack_public_path__ + "static/media/startup_banner_img.b143a12c.png";